export type PendingExternalLink = {
  url: string;
  hostname: string;
};

type ExternalLinkClickMessage = {
  type: 'externalLinkClick';
  url: string;
};

const isExternalLinkClickMessage = (
  data: unknown
): data is ExternalLinkClickMessage => {
  if (data === null || typeof data !== 'object') {
    return false;
  }

  const messagePayload = data as { type?: unknown; url?: unknown };
  return (
    messagePayload.type === 'externalLinkClick' &&
    typeof messagePayload.url === 'string'
  );
};

export const parseExternalLinkForModal = (
  url: string
): PendingExternalLink | null => {
  let parsedUrl: URL;

  try {
    parsedUrl = new URL(url);
  } catch (_error) {
    return null;
  }

  if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
    return null;
  }

  const hostname = parsedUrl.hostname.replace(/^www\./, '');
  if (!hostname) {
    return null;
  }

  return {
    url: parsedUrl.toString(),
    hostname,
  };
};

export const getPendingExternalLinkFromMessage = (
  data: unknown
): PendingExternalLink | null => {
  if (!isExternalLinkClickMessage(data)) {
    return null;
  }
  return parseExternalLinkForModal(data.url);
};
